define('casino/quick-change',['jquery', 'casino/casino', 'all/dialog', 'casino/allgames', 'casino/search', 'casino/casino-data', 'all/template'], function($, casino, dialog, allgames, search, casinoData) {
	'use strict';

	$(init);
	function init() {

		$('.quick-change').click(function() {
			var $gh = $(this).parents('.game-holder');
			var oldGameId = $gh.data('game.id');

			var data = {};

			dialog.load('quickChange', data,
				function onLoad() {
					var $dialog = $(this);

					hideGames();

					var $allGames = $('#casino-allgames').clone();
					prepareAllGamesForQuickChange($allGames);
					populateDialogWithGames($dialog, $allGames);
					prepareSearchForQuickChange($allGames);

					search.init($allGames.find('#quick-gamesearch'));

					allgames.setup($allGames, {
						gamesPerPage: 8
					});

					$allGames.scroller({
						direction: 'left',
						auto: false
					});

					overrideMousedownOnGameIcons($dialog);

				}, function onCancel() {
				showGames();
			});

			function overrideMousedownOnGameIcons($dialog) {
				$dialog.find('section[data-game]').off('mousedown').on('mousedown', function() {
					casino.replaceGameIdInLocationHash(oldGameId, $(this).data('game'));
				});
			}
		});
	}

	function hideGames() {
		$('object[id^=loaded]').hide();
	}

	function showGames() {
		$('object[id^=loaded]').show();
	}

	function prepareAllGamesForQuickChange($allGames) {
		$allGames.show();
		$allGames.find('section.area[data-show-in-quick-change="false"]').remove();
		$allGames.find('#filter-categories li').removeClass('active');
		$allGames.find('#sort-games a').removeClass('active');
		$allGames.find('#sort-games a').first().addClass('active');
	}

	function prepareSearchForQuickChange($allGames) {
		var $search = $allGames.find('#quick-search');
		$search.show();
		var $searchResultTemplate = $('#quick-change-searchresults');
		var $searchField = $allGames.find('#quick-gamesearch');
		var hasStartedToSearch = false;
		var hasOverlay = false;

		$searchField.keyup(function() {
			var searchValue = $searchField.val();
			if (searchValue.length > 2 || hasStartedToSearch) {
				var $quickchange = $('#dialog-quickchange');
				if (searchValue.length < 1 && hasOverlay) {
					if (hasOverlay) {
						$allGames.find('#quick-change-searchresults').remove();
						$allGames.find('#all-games').show();
						$quickchange.find('.cnt-popup').removeClass('search');
						hasOverlay = false;
						hasStartedToSearch = false;
						$allGames.find('#rightcolumn h1:first').applyTemplate({
							count: allgames.currentCount(),
							total: Object.keys(casinoData.games).length
						});
						return;
					}
				}
				hasStartedToSearch = true;
				$allGames.find('.grid-8 .area').find('#quick-change-searchresults').remove();
				$allGames.find('#all-games').hide();
				var quickSearchResult = $searchResultTemplate.clone();
				$allGames.find('.grid-8 .area').append(quickSearchResult);
				quickSearchResult.show();
				var numberOfGames = search.games($allGames.find('#quick-gamesearch'), $allGames.find('#quick-change-searchresults'), {
					gamesPerPage: 8,
					hasStarted: true
				});

				$allGames.find('#rightcolumn h1:first').applyTemplate({
					count: numberOfGames,
					total: Object.keys(casinoData.games).length
				});

				if (!hasOverlay) {
					hasOverlay = true;
					$quickchange.find('[data-clear-search="true"]').click(function() {
						$allGames.find('#rightcolumn h1:first').applyTemplate({
							count: allgames.currentCount(),
							total: Object.keys(casinoData.games).length
						});
						$allGames.find('#quick-change-searchresults').remove();
						$searchField.val($searchField.data('default'));
						$allGames.find('#all-games').show();
						$('#dialog-quickchange').find('.cnt-popup').removeClass('search');
						hasOverlay = false;
						hasStartedToSearch = false;
					});
					$quickchange.find('.cnt-popup').addClass('search');
				}
			}
		});
	}

	function populateDialogWithGames($dialog, $allGames) {
		$dialog.find('div').first().append($allGames);
	}


});

